var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['evaluation-badge', 'badge', 'badge-value-' + _vm.value, _vm.outline ? 'badge-parent' : null]},[_vm._v("\n  "+_vm._s(_vm.choices[_vm.value])+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f085f4e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/EvaluationBadge.vue
// module id = bh8x
// module chunks = 70